module.exports = __webpack_public_path__ + "76dd87a0e9a6b28f46360d4f9c6e59c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/excel_download.svg
// module id = 1174
// module chunks = 0